const LOGO_PRIMARY_BLACK = `${process.env.PUBLIC_URL}/images/logos/logo-primary-black.webp`;

const Page404 = () => {
  return (
    <div
      className="error-page p-absolute"
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <a
        className="text-decoration-none"
        href="https://www.trustfinance.com/"
        style={{ color: "unset" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div
          className="wrapper"
          style={{
            padding: "18px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={LOGO_PRIMARY_BLACK} alt="TrustFinance" height={42} />
        </div>
      </a>
    </div>
  );
};

export default Page404;
